import Vue from 'vue'

const Menus = {
  namespaced: true,

  state: {
    menus: [],
    selectedMenu: {
      0: null,
      1: null,
      2: null
    },
    menuDialog: false,
    currentMenu: null
  },

  mutations: {
    setSelectedMenu(state, { level, menuId }) {
      state.selectedMenu[level] = menuId
      /* eslint-disable no-fallthrough */
      switch (level) {
        case 0: state.selectedMenu[1] = null
        case 1: state.selectedMenu[2] = null
        case 2: state.selectedMenu[level] = menuId
        default:
      }
      /* eslint-enable no-fallthrough */
    },
    openMenuDialog(state, menu) {
      state.currentMenu = { ...menu }
      state.menuDialog = true
    },
    closeMenuDialog(state) {
      state.menuDialog = false
    }
  },

  actions: {
    async getAll({ state }) {
      const response = await Vue.axios.get('/menus')
      const menus = response.data.data
      state.menus = menus || []
    },
    async createMenuItem({ state }, { name, parent_id, order }) {
      const response = await Vue.axios.post('/menu', { name, parent_id, order })
      state.menus.push(response.data.data)
    },
    async updateMenuOrder({ state }, menus) {
      const promises = state.menus.reduce((target, menu) => {
        const ordered = menus.find(m => m.id === menu.id)
        if (ordered) {
          menu.order = ordered.order
          target.push(Vue.axios.put(`/menu/${menu.id}`, menu))
        }
        return target
      }, [])
      await Promise.all(promises)
    },
    async validateMenu({ commit, state }) {
      const response = await Vue.axios.put(`/menu/${state.currentMenu.id}`, state.currentMenu)
      const updatedMenu = response.data.data
      const index = state.menus.findIndex(m => m.id === updatedMenu.id)
      state.menus.splice(index, 1, updatedMenu)
      commit('closeMenuDialog')
    },
    async removeMenu({ commit, state }) {
      const { id } = state.currentMenu
      await Vue.axios.delete(`/menu/${id}`)

      const index = state.menus.findIndex(m => m.id === id)
      state.menus.splice(index, 1)

      const selectedIndex = Object.values(state.selectedMenu).indexOf(id)
      if (selectedIndex > -1) commit('setSelectedMenu', { level: selectedIndex, menuId: null })

      commit('closeMenuDialog')
    }
  }
}

export default Menus
